import {VERIFY_HINTING_CLOSE_COUNT} from '@front/constant';

export let VERIFY_HINTING_CLOSE_COUNT_STORAGE_KEY = VERIFY_HINTING_CLOSE_COUNT;

export function setVerifyHintingCloseCountStorageKey(userId) {
  VERIFY_HINTING_CLOSE_COUNT_STORAGE_KEY = VERIFY_HINTING_CLOSE_COUNT + '_' + userId;
}
